import { server_url } from "@script/config";
import type * as type from "@vTypes";

export async function listcnt() {
  const response = await fetch(`${server_url}/push/listcnt`, {
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Fetch failed: ${response.status}`);
  }
  const result = await response.json();
  return result;
}

export async function list(size: number) {
  const response = await fetch(`${server_url}/push/list?listsize=${size}`, {
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Fetch failed: ${response.status}`);
  }
  const result = await response.json();

  // 디버깅: 응답 구조 확인
  console.log("alarm.list response:", result);
  console.log("alarm.list response type:", typeof result);
  console.log("alarm.list isArray:", Array.isArray(result));
  if (Array.isArray(result)) {
    console.log("alarm.list array length:", result.length);
  }

  // 기존 엔드포인트이므로 배열을 직접 반환
  const alarmList: type.AlarmItem[] = Array.isArray(result) ? result : [];
  console.log("alarm.list returning, length:", alarmList.length);
  return alarmList;
}

export async function markAllAsRead() {
  const response = await fetch(`${server_url}/push/read/all`, {
    method: "PATCH",
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Fetch failed: ${response.status}`);
  }
  const result = await response.json();
  return result;
}

// 개별 알림 읽음 처리 (pushcode, pushsubcode 필요)
export async function markAsRead(
  pushcode: string,
  pushsubcode: string,
  officecode: string
) {
  const response = await fetch(
    `${server_url}/push/read?pushcode=${pushcode}&pushsubcode=${pushsubcode}&officecode=${officecode}`,
    {
      method: "PATCH",
      credentials: "include",
    }
  );
  if (!response.ok) {
    throw new Error(`Fetch failed: ${response.status}`);
  }
  const result = await response.json();
  return result;
}

// 단건 알림 읽음 처리 (fk_idx 기준)
export async function markOneRead(fkIdx: number) {
  const response = await fetch(`${server_url}/push/read/one`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ fk_idx: fkIdx }),
  });
  if (!response.ok) {
    throw new Error(`Fetch failed: ${response.status}`);
  }
  const result = await response.json();
  return result;
}
